// extracted by mini-css-extract-plugin
module.exports = {"root":"_2192E","background":"RsX1o","content":"_2ER8Y","mainText":"_2kPOD","mainTextSmall":"_34Byy","link":"_1MNw9"};